import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _aggregatedNumberOfUnseenRequest = {};
var _aggregatedNumberOfUnseenResponse = {};
var _deleteByServerRequest = {};
var _deleteByServerResponse = {};
var _deleteRequest = {};
var _dismissAlertRequest = {};
var _empty = {};
var _feedNotification = { sentAt: 'google.protobuf.Timestamp' };
var _getAlertsRequest = {};
var _getAlertsResponse = { notifications: '_feedNotification' };
var _getFeedRequest = {};
var _getFeedResponse = { notifications: '_feedNotification' };
var _getTopicBasedAggregatedNumberOfUnseenNotificationsRequest = {};
var _getTopicBasedAggregatedNumberOfUnseenNotificationsResponse = {};
var _getUnifiedFeedRequest = {};
var _getUnifiedFeedResponse = { notifications: '_feedNotification' };
var _getUnseenNotificationCountsRequest = {};
var _getUnseenNotificationCountsResponse = {};
var _markAllAsReadRequest = {};
var _markAsReadRequest = {};
var _markAsSeenRequest = {};
var _markAsUnreadRequest = {};
var _numberOfUnseenRequest = {};
var _numberOfUnseenResponse = {};
function resolveComWixpressPingFeedApiFeedServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/notifications-feed-api-proxy',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/ping/feed',
                destPath: '/api/v1/feed/notifications',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/ping/feed',
                destPath: '/api/v1/feed/notifications',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/ping/feed',
                destPath: '/api/v1/feed/notifications',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/ping/feed',
                destPath: '/api/v1/feed/notifications',
            },
        ],
        'gapps._base_domain_': [
            {
                srcPath: '/_api/ping/feed',
                destPath: '/api/v1/feed/notifications',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/ping/feed',
                destPath: '/api/v1/feed/notifications',
            },
            {
                srcPath: '/_api/ping/notifications-feed/v1/feed',
                destPath: '/v1/feed',
            },
            {
                srcPath: '/_api/ping/notifications-feed/api/v1/feed',
                destPath: '/api/v1/feed',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/ping/feed',
                destPath: '/api/v1/feed/notifications',
            },
            {
                srcPath: '/_api/ping/notifications-feed/v1/feed',
                destPath: '/v1/feed',
            },
            {
                srcPath: '/_api/ping/notifications-feed/api/v1/feed',
                destPath: '/api/v1/feed',
            },
        ],
        _: [
            {
                srcPath: '/_api/ping/feed',
                destPath: '/api/v1/feed/notifications',
            },
            {
                srcPath: '/api/ping/feed',
                destPath: '',
            },
            {
                srcPath: '/api/v1/feed/notifications',
                destPath: '/api/v1/feed/notifications',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/api/v1/feed/notifications',
                destPath: '/api/v1/feed/notifications',
            },
            {
                srcPath: '/_api/ping/feed',
                destPath: '/api/v1/feed/notifications',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** query number of unseen notifications */
export function getNumberOfUnseenNotifications(payload) {
    var _a = serializer(_numberOfUnseenRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_numberOfUnseenResponse, {}).fromJSON;
    function __getNumberOfUnseenNotifications(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.feed.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.feed.api.FeedService.GetNumberOfUnseenNotifications',
            url: resolveComWixpressPingFeedApiFeedServiceUrl({
                protoPath: '/api/v1/feed/notifications/unseen-notifications',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getNumberOfUnseenNotifications.fromReq = fromReq;
    __getNumberOfUnseenNotifications.__isAmbassador = true;
    return __getNumberOfUnseenNotifications;
}
/** get number of unseen counts */
export function getUnseenNotificationCounts(payload) {
    var _a = serializer(_getUnseenNotificationCountsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getUnseenNotificationCountsResponse, {}).fromJSON;
    function __getUnseenNotificationCounts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.feed.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.feed.api.FeedService.GetUnseenNotificationCounts',
            url: resolveComWixpressPingFeedApiFeedServiceUrl({
                protoPath: '/api/v1/feed/notifications/unseen-counts',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getUnseenNotificationCounts.fromReq = fromReq;
    __getUnseenNotificationCounts.__isAmbassador = true;
    return __getUnseenNotificationCounts;
}
/** get feed */
export function getFeed(payload) {
    var _a = serializer(_getFeedRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFeedResponse, {
        _feedNotification: _feedNotification,
    }).fromJSON;
    function __getFeed(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.feed.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.feed.api.FeedService.GetFeed',
            url: resolveComWixpressPingFeedApiFeedServiceUrl({
                protoPath: '/api/v1/feed/notifications/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getFeed.fromReq = fromReq;
    __getFeed.__isAmbassador = true;
    return __getFeed;
}
/** get unified feed */
export function getUnifiedFeed(payload) {
    var _a = serializer(_getUnifiedFeedRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getUnifiedFeedResponse, {
        _feedNotification: _feedNotification,
    }).fromJSON;
    function __getUnifiedFeed(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.feed.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.feed.api.FeedService.GetUnifiedFeed',
            url: resolveComWixpressPingFeedApiFeedServiceUrl({
                protoPath: '/api/v1/unified-feed/notifications/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getUnifiedFeed.fromReq = fromReq;
    __getUnifiedFeed.__isAmbassador = true;
    return __getUnifiedFeed;
}
/** get alerts */
export function getAlerts(payload) {
    var _a = serializer(_getAlertsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAlertsResponse, {
        _feedNotification: _feedNotification,
    }).fromJSON;
    function __getAlerts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.feed.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.feed.api.FeedService.GetAlerts',
            url: resolveComWixpressPingFeedApiFeedServiceUrl({
                protoPath: '/v1/feed/notifications/get-alerts',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAlerts.fromReq = fromReq;
    __getAlerts.__isAmbassador = true;
    return __getAlerts;
}
/** mark as seen from timestamp */
export function markAsSeen(payload) {
    var _a = serializer(_markAsSeenRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_empty, {}).fromJSON;
    function __markAsSeen(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.feed.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.feed.api.FeedService.MarkAsSeen',
            url: resolveComWixpressPingFeedApiFeedServiceUrl({
                protoPath: '/api/v1/feed/notifications/mark-as-seen',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markAsSeen.fromReq = fromReq;
    __markAsSeen.__isAmbassador = true;
    return __markAsSeen;
}
/** mark list of notifications as read */
export function markAsRead(payload) {
    var _a = serializer(_markAsReadRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_empty, {}).fromJSON;
    function __markAsRead(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.feed.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.feed.api.FeedService.MarkAsRead',
            url: resolveComWixpressPingFeedApiFeedServiceUrl({
                protoPath: '/api/v1/feed/notifications/mark-as-read',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markAsRead.fromReq = fromReq;
    __markAsRead.__isAmbassador = true;
    return __markAsRead;
}
/** mark list of notifications as unread */
export function markAsUnread(payload) {
    var _a = serializer(_markAsUnreadRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_empty, {}).fromJSON;
    function __markAsUnread(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.feed.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.feed.api.FeedService.MarkAsUnread',
            url: resolveComWixpressPingFeedApiFeedServiceUrl({
                protoPath: '/api/v1/feed/notifications/mark-as-unread',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markAsUnread.fromReq = fromReq;
    __markAsUnread.__isAmbassador = true;
    return __markAsUnread;
}
/** mark all notification in the feed as read */
export function markAllAsRead(payload) {
    var _a = serializer(_markAllAsReadRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_empty, {}).fromJSON;
    function __markAllAsRead(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.feed.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.feed.api.FeedService.MarkAllAsRead',
            url: resolveComWixpressPingFeedApiFeedServiceUrl({
                protoPath: '/api/v1/feed/notifications/mark-all-read',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markAllAsRead.fromReq = fromReq;
    __markAllAsRead.__isAmbassador = true;
    return __markAllAsRead;
}
/** dismiss alert notification */
export function dismissAlert(payload) {
    var _a = serializer(_dismissAlertRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_empty, {}).fromJSON;
    function __dismissAlert(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.feed.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.feed.api.FeedService.DismissAlert',
            url: resolveComWixpressPingFeedApiFeedServiceUrl({
                protoPath: '/v1/feed/notifications/dismiss-alerts',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __dismissAlert.fromReq = fromReq;
    __dismissAlert.__isAmbassador = true;
    return __dismissAlert;
}
/** query number of unseen notifications for a user in all his sites. */
export function getAggregatedNumberOfUnseenNotifications(payload) {
    var _a = serializer(_aggregatedNumberOfUnseenRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_aggregatedNumberOfUnseenResponse, {}).fromJSON;
    function __getAggregatedNumberOfUnseenNotifications(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.feed.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.feed.api.FeedService.GetAggregatedNumberOfUnseenNotifications',
            url: resolveComWixpressPingFeedApiFeedServiceUrl({
                protoPath: '/v1/feed/notifications/get-aggregated-number-of-unseen-notifications',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAggregatedNumberOfUnseenNotifications.fromReq = fromReq;
    __getAggregatedNumberOfUnseenNotifications.__isAmbassador = true;
    return __getAggregatedNumberOfUnseenNotifications;
}
/** query number of unseen notifications for a user in all his sites. */
export function getTopicBasedAggregatedNumberOfUnseenNotifications(payload) {
    var _a = serializer(_getTopicBasedAggregatedNumberOfUnseenNotificationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTopicBasedAggregatedNumberOfUnseenNotificationsResponse, {}).fromJSON;
    function __getTopicBasedAggregatedNumberOfUnseenNotifications(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.feed.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.feed.api.FeedService.GetTopicBasedAggregatedNumberOfUnseenNotifications',
            url: resolveComWixpressPingFeedApiFeedServiceUrl({
                protoPath: '/v1/feed/notifications/get-topic-based-aggregated-number-of-unseen-notifications',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTopicBasedAggregatedNumberOfUnseenNotifications.fromReq = fromReq;
    __getTopicBasedAggregatedNumberOfUnseenNotifications.__isAmbassador = true;
    return __getTopicBasedAggregatedNumberOfUnseenNotifications;
}
/** delete notification */
export function _delete(payload) {
    var _a = serializer(_deleteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_empty, {}).fromJSON;
    function ___delete(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.feed.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.feed.api.FeedService._Delete',
            url: resolveComWixpressPingFeedApiFeedServiceUrl({
                protoPath: '/api/v1/feed/notifications/delete-notification',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    ___delete.fromReq = fromReq;
    ___delete.__isAmbassador = true;
    return ___delete;
}
/** delete notification by server TODO: delete after google ads fixing alerts issue */
export function deleteByServer(payload) {
    var _a = serializer(_deleteByServerRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteByServerResponse, {}).fromJSON;
    function __deleteByServer(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.feed.v1.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.feed.api.FeedService.DeleteByServer',
            url: resolveComWixpressPingFeedApiFeedServiceUrl({
                protoPath: '/api/v1/feed/notifications/delete-notification-by-server',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteByServer.fromReq = fromReq;
    __deleteByServer.__isAmbassador = true;
    return __deleteByServer;
}
//# sourceMappingURL=http.impl.js.map